import {
  TransportTypeEnum,
  transportTypeMapping,
  TransportTypeOption,
  tripStepTypeMapping
} from '../../types/enums/trip/trip-type.enum'
import { TripStepTypeEnum } from '../../types/enums/trip-bookings/trip-step-type.enum'

/**
 * Badge of a block on the staff travel schedule ("Mes horaires de voyages") and on the client
 * space "RDV trajet aller/retour".
 * The departure block reads "Aller" when a return block is shown next to it,
 * "Aller Simple" only when there is no return.
 */
export function getTravelScheduleTripTypeOption(
  directionality: TripStepTypeEnum,
  hasReturnTrip = false
): TransportTypeOption {
  if (directionality === TripStepTypeEnum.OUTBOUND)
    return transportTypeMapping[TransportTypeEnum.RETURN]

  return hasReturnTrip
    ? tripStepTypeMapping[TripStepTypeEnum.INBOUND]
    : transportTypeMapping[TransportTypeEnum.ONE_WAY]
}
